// // export const generateJourneyDates = (
// //   journeys: { journeyDate: string }[],
// //   selectedDate?: Date | null,
// // ) => {
// //   const today = new Date();
// //   today.setHours(0, 0, 0, 0);

// //   const journeyDates = journeys.map(
// //     (j) => new Date(j.journeyDate),
// //   );

// //   const earliest =
// //     journeyDates.length > 0
// //       ? new Date(Math.min(...journeyDates.map((d) => d.getTime())))
// //       : today;

// //   const dates: Date[] = [];

// //   for (
// //     let d = new Date(earliest);
// //     d <= today;
// //     d.setDate(d.getDate() + 1)
// //   ) {
// //     dates.push(new Date(d));
// //   }

// //   return dates;
// // };
// // import { JourneyItem } from "../components/Journey/journey.types";
// import { JourneyItem } from "../Journey/journey.types";
// /**
//  * Generate dates for the slider based on existing journeys
//  * Shows dates from first journey to selected date
//  */
// export const generateJourneyDates = (
//   existingJourneys: JourneyItem[],
//   selectedDate: Date | null
// ): Date[] => {
//   if (existingJourneys.length === 0) {
//     // If no journeys, show last 7 days + today
//     return getLast7Days();
//   }

//   const sortedJourneys = [...existingJourneys].sort(
//     (a, b) =>
//       new Date(a.journeyDate).getTime() - new Date(b.journeyDate).getTime()
//   );

//   const firstJourneyDate = new Date(sortedJourneys[0].journeyDate);
//   const endDate = selectedDate || new Date();

//   const dates: Date[] = [];
//   const currentDate = new Date(firstJourneyDate);
//   currentDate.setHours(0, 0, 0, 0);

//   const end = new Date(endDate);
//   end.setHours(0, 0, 0, 0);

//   while (currentDate <= end) {
//     dates.push(new Date(currentDate));
//     currentDate.setDate(currentDate.getDate() + 1);
//   }

//   return dates;
// };

// /**
//  * Get last 7 days including today
//  */
// export const getLast7Days = (): Date[] => {
//   const dates: Date[] = [];
//   const today = new Date();

//   for (let i = 6; i >= 0; i--) {
//     const date = new Date(today);
//     date.setDate(date.getDate() - i);
//     date.setHours(0, 0, 0, 0);
//     dates.push(date);
//   }

//   return dates;
// };

// /**
//  * Check if a date already has a journey
//  */
// export const hasJourneyForDate = (
//   date: Date,
//   journeys: JourneyItem[]
// ): boolean => {
//   const dateStr = date.toISOString().split("T")[0];
//   return journeys.some(
//     (j) => new Date(j.journeyDate).toISOString().split("T")[0] === dateStr
//   );
// };

// /**
//  * Get missed dates (dates without journeys between first journey and today)
//  */
// export const getMissedDates = (journeys: JourneyItem[]): Date[] => {
//   if (journeys.length === 0) return [];

//   const sortedJourneys = [...journeys].sort(
//     (a, b) =>
//       new Date(a.journeyDate).getTime() - new Date(b.journeyDate).getTime()
//   );

//   const firstJourneyDate = new Date(sortedJourneys[0].journeyDate);
//   firstJourneyDate.setHours(0, 0, 0, 0);

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const missed: Date[] = [];
//   const currentDate = new Date(firstJourneyDate);

//   while (currentDate < today) {
//     currentDate.setDate(currentDate.getDate() + 1);

//     const hasJourney = journeys.some(
//       (j) =>
//         new Date(j.journeyDate).toISOString().split("T")[0] ===
//         currentDate.toISOString().split("T")[0]
//     );

//     // Skip Sundays (optional - remove if you want to track Sundays)
//     const isSunday = currentDate.getDay() === 0;

//     if (!hasJourney && !isSunday && currentDate < today) {
//       missed.push(new Date(currentDate));
//     }
//   }

//   return missed;
// };

// /**
//  * Format date for display
//  */
// export const formatDateDisplay = (date: Date): string => {
//   return date.toLocaleDateString("en-US", {
//     weekday: "short",
//     month: "short",
//     day: "numeric",
//     year: "numeric",
//   });
// };
// import { JourneyItem } from "../components/Journey/journey.types";
// import { JourneyItem } from "../Journey/journey.types";
// /**
//  * Generate dates for the slider based on existing journeys
//  * Shows dates from first journey to selected date
//  */
// export const generateJourneyDates = (
//   existingJourneys: JourneyItem[],
//   selectedDate: Date | null
// ): Date[] => {
//   if (existingJourneys.length === 0) {
//     // If no journeys, show last 7 days + today
//     return getLast7Days();
//   }

//   const sortedJourneys = [...existingJourneys].sort(
//     (a, b) =>
//       new Date(a.journeyDate).getTime() - new Date(b.journeyDate).getTime()
//   );

//   const firstJourneyDate = new Date(sortedJourneys[0].journeyDate);
//   const endDate = selectedDate || new Date();

//   const dates: Date[] = [];
//   const currentDate = new Date(firstJourneyDate);
//   currentDate.setHours(0, 0, 0, 0);

//   const end = new Date(endDate);
//   end.setHours(0, 0, 0, 0);

//   while (currentDate <= end) {
//     dates.push(new Date(currentDate));
//     currentDate.setDate(currentDate.getDate() + 1);
//   }

//   return dates;
// };

// /**
//  * Get last 7 days including today
//  */
// export const getLast7Days = (): Date[] => {
//   const dates: Date[] = [];
//   const today = new Date();

//   for (let i = 6; i >= 0; i--) {
//     const date = new Date(today);
//     date.setDate(date.getDate() - i);
//     date.setHours(0, 0, 0, 0);
//     dates.push(date);
//   }

//   return dates;
// };

// /**
//  * Check if a date already has a journey
//  */
// export const hasJourneyForDate = (
//   date: Date,
//   journeys: JourneyItem[]
// ): boolean => {
//   const dateStr = date.toISOString().split("T")[0];
//   return journeys.some(
//     (j) => new Date(j.journeyDate).toISOString().split("T")[0] === dateStr
//   );
// };

// /**
//  * Get missed dates (dates without journeys between first journey and today)
//  */
// export const getMissedDates = (journeys: JourneyItem[]): Date[] => {
//   if (journeys.length === 0) return [];

//   const sortedJourneys = [...journeys].sort(
//     (a, b) =>
//       new Date(a.journeyDate).getTime() - new Date(b.journeyDate).getTime()
//   );

//   const firstJourneyDate = new Date(sortedJourneys[0].journeyDate);
//   firstJourneyDate.setHours(0, 0, 0, 0);

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const missed: Date[] = [];
//   const currentDate = new Date(firstJourneyDate);

//   while (currentDate < today) {
//     currentDate.setDate(currentDate.getDate() + 1);

//     const hasJourney = journeys.some(
//       (j) =>
//         new Date(j.journeyDate).toISOString().split("T")[0] ===
//         currentDate.toISOString().split("T")[0]
//     );

//     // Skip Sundays (optional - remove if you want to track Sundays)
//     const isSunday = currentDate.getDay() === 0;

//     if (!hasJourney && !isSunday && currentDate < today) {
//       missed.push(new Date(currentDate));
//     }
//   }

//   return missed;
// };

// /**
//  * Format date for display
//  */
// export const formatDateDisplay = (date: Date): string => {
//   return date.toLocaleDateString("en-US", {
//     weekday: "short",
//     month: "short",
//     day: "numeric",
//     year: "numeric",
//   });
// };
import { JourneyItem } from "../Journey/journey.types";

/**
 * Format date to YYYY-MM-DD using LOCAL time
 * Safe replacement for toISOString().split('T')[0] which uses UTC
 */
export const formatToLocalDateISO = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Get dates that have journey entries
 */
export const getJourneyDates = (journeys: JourneyItem[]): Date[] => {
  return journeys
    .map((j) => new Date(j.journeyDate))
    .sort((a, b) => a.getTime() - b.getTime());
};

/**
 * Get missed dates — dates that have NO journey record between first journey and upToDate.
 * A date is "missed" if no journey entry exists for it at all.
 * The first journey date itself is NOT considered missed (it's the anchor).
 *
 * @param journeys - All journey items for the batch
 * @param upToDate - Check dates up to (but NOT including) this date. Defaults to today.
 */
export const getMissedDates = (
  journeys: JourneyItem[],
  upToDate?: Date
): Date[] => {
  if (journeys.length === 0) return [];

  const dates = getJourneyDates(journeys);
  if (dates.length === 0) return [];

  const firstDate = new Date(dates[0]);
  firstDate.setHours(0, 0, 0, 0);

  const endDate = upToDate ? new Date(upToDate) : new Date();
  endDate.setHours(0, 0, 0, 0);

  // Build a set of all dates that have journey records
  const journeyDateSet = new Set<string>(
    journeys.map((j) => j.journeyDate)
  );

  const missedDates: Date[] = [];
  const current = new Date(firstDate);
  // Start from the day AFTER the first journey (first journey is the anchor)
  current.setDate(current.getDate() + 1);

  while (current < endDate) {
    const dateStr = formatToLocalDateISO(current);

    // Missed if no journey record exists for this date
    if (!journeyDateSet.has(dateStr)) {
      missedDates.push(new Date(current));
    }
    current.setDate(current.getDate() + 1);
  }

  return missedDates;
};

/**
 * Generate date slider dates
 * Shows: [existing dates, missed dates between, selected date if not present]
 * 
 * UPDATED: Always show all dates in proper order
 */
// export const generateJourneyDates = (
//   journeys: JourneyItem[],
//   selectedDate: Date
// ): Date[] => {
//   if (!selectedDate) return getJourneyDates(journeys);

//   const selectedDateStr = selectedDate.toISOString().split("T")[0];

//   // Get existing journey dates
//   const journeyDates = getJourneyDates(journeys);
//   const journeyDateStrings = new Set(
//     journeyDates.map((d) => d.toISOString().split("T")[0])
//   );

//   // If no journeys yet, show only selected date
//   if (journeyDates.length === 0) {
//     return [selectedDate];
//   }

//   // Determine the range to show
//   const firstJourneyDate = journeyDates[0];
//   const lastJourneyDate = journeyDates[journeyDates.length - 1];

//   // Start from earliest date (either first journey or selected date if earlier)
//   const startDate = new Date(
//     Math.min(firstJourneyDate.getTime(), selectedDate.getTime())
//   );

//   // End at latest date (either last journey or selected date if later)
//   const endDate = new Date(
//     Math.max(lastJourneyDate.getTime(), selectedDate.getTime())
//   );

//   // Generate all dates in range
//   const allDates: Date[] = [];
//   const allDateStrings = new Set<string>();
//   const current = new Date(startDate);

//   while (current <= endDate) {
//     const dateStr = current.toISOString().split("T")[0];
//     if (!allDateStrings.has(dateStr)) {
//       allDates.push(new Date(current));
//       allDateStrings.add(dateStr);
//     }
//     current.setDate(current.getDate() + 1);
//   }

//   // Add selected date if not in range
//   if (!allDateStrings.has(selectedDateStr)) {
//     allDates.push(new Date(selectedDate));
//   }

//   // Sort chronologically
//   return allDates.sort((a, b) => a.getTime() - b.getTime());
// };

export const generateJourneyDates = (
  journeys: JourneyItem[],
  selectedDate: Date
): Date[] => {
  if (!selectedDate) return [];

  // If no journeys, just show selected date
  if (journeys.length === 0) {
    return [selectedDate];
  }

  // Get the earliest journey date
  const sortedDates = getJourneyDates(journeys);
  const firstDate = new Date(sortedDates[0]);
  firstDate.setHours(0, 0, 0, 0);

  const endDate = new Date(selectedDate);
  endDate.setHours(0, 0, 0, 0);

  // Generate ALL dates from first journey to selected date (inclusive)
  // Use formatToLocalDateISO for consistent dedup (prevents UTC/local duplicates)
  const allDates: Date[] = [];
  const allDateStrings = new Set<string>();
  const current = new Date(firstDate);

  while (current <= endDate) {
    const dateStr = formatToLocalDateISO(current);
    if (!allDateStrings.has(dateStr)) {
      allDates.push(new Date(current));
      allDateStrings.add(dateStr);
    }
    current.setDate(current.getDate() + 1);
  }

  // If selected date is not in range, add it
  const selectedStr = formatToLocalDateISO(selectedDate);
  if (!allDateStrings.has(selectedStr)) {
    allDates.push(new Date(selectedDate));
  }

  return allDates.sort((a, b) => a.getTime() - b.getTime());
};

/**
 * Check if a date has a journey entry
 */
export const hasJourney = (journeys: JourneyItem[], date: Date): boolean => {
  const dateStr = date.toISOString().split("T")[0];
  return journeys.some((j) => j.journeyDate === dateStr);
};

/**
 * Get journey for a specific date
 */
export const getJourneyForDate = (
  journeys: JourneyItem[],
  date: Date
): JourneyItem | undefined => {
  const dateStr = date.toISOString().split("T")[0];
  return journeys.find((j) => j.journeyDate === dateStr);
};

/**
 * Format date for display
 */
export const formatDateDisplay = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

/**
 * Format date short (for sliders)
 */
export const formatDateShort = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

/**
 * Check if date is today
 */
export const isToday = (date: Date): boolean => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

/**
 * Get next available date for journey
 * (First date without entry, or tomorrow if all dates have entries)
 */
export const getNextAvailableDate = (journeys: JourneyItem[]): Date => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (journeys.length === 0) {
    return today;
  }

  const journeyDateStrings = new Set(
    journeys.map((j) => j.journeyDate)
  );

  // Check today
  if (!journeyDateStrings.has(today.toISOString().split("T")[0])) {
    return today;
  }

  // Check tomorrow
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  return tomorrow;
};